import React from 'react';
import './PromptFormatTabs.css';

/**
 * Component for switching between prompt format types: Structured, Free Text
 * @param {Object} props
 * @param {string} props.activeFormat - Current active format: 'STRUCTURED' or 'FREE_TEXT'
 * @param {Function} props.onFormatChange - Callback when format changes
 */
const PromptFormatTabs = ({ activeFormat, onFormatChange }) => {
  const handleTabClick = (format, e) => {
    e.preventDefault();
    e.stopPropagation();
    onFormatChange(format);
  };

  return (
    <div className="prompt-format-tabs">
      <button
        type="button"
        className={`format-tab ${activeFormat === 'STRUCTURED' ? 'active' : ''}`}
        onClick={(e) => handleTabClick('STRUCTURED', e)}
        aria-label="Structured Format"
      >
        Structured Format
      </button>
      <button
        type="button"
        className={`format-tab ${activeFormat === 'FREE_TEXT' ? 'active' : ''}`}
        onClick={(e) => handleTabClick('FREE_TEXT', e)}
        aria-label="Free Text"
      >
        Free Text
      </button>
    </div>
  );
};

export default PromptFormatTabs;
